import { useTranslation } from 'react-i18next';

import { TransactionFilters as TransactionFiltersType } from '../../store/api/balanceApi';

interface TransactionFiltersProps {
  filters: TransactionFiltersType;
  onFiltersChange: (filters: TransactionFiltersType) => void;
}

export function TransactionFilters({ filters, onFiltersChange }: TransactionFiltersProps) {
  const { t } = useTranslation();

  const handleFilterChange = (key: keyof TransactionFiltersType, value: string | number | undefined) => {
    onFiltersChange({
      ...filters,
      [key]: value || undefined,
      page: 1, // Reset to first page when filter changes
    });
  };

  return (
    <div className="card-glass rounded-lg p-4 space-y-4">
      <h3 className="text-lg font-heading font-semibold text-brand-accent mb-4">
        {t('transactions.filters.title')}
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Type Filter */}
        <div>
          <label className="block text-sm font-medium text-neutral-light mb-2 font-body">
            {t('transactions.filters.type')}
          </label>
          <select
            value={filters.type || ''}
            onChange={(e) => handleFilterChange('type', e.target.value || undefined)}
            className="w-full px-4 py-2 card-glass rounded-lg text-neutral-light focus:outline-none focus:ring-2 focus:ring-brand-accent focus:border-transparent transition-all duration-300 font-body"
          >
            <option value="">{t('transactions.filters.all')}</option>
            <option value="recharge">{t('transactions.types.recharge')}</option>
            <option value="purchase">{t('transactions.types.purchase')}</option>
            <option value="referral_bonus">{t('transactions.types.referralBonus')}</option>
            <option value="refund">{t('transactions.types.refund')}</option>
            <option value="admin_add">{t('transactions.types.adminAdd')}</option>
            <option value="admin_deduct">{t('transactions.types.adminDeduct')}</option>
            <option value="cashback_claim">{t('transactions.types.cashbackClaim')}</option>
            <option value="cashback_earn">{t('transactions.types.cashbackEarn')}</option>
            <option value="admin_add_referral">{t('transactions.types.adminAddReferral')}</option>
            <option value="admin_deduct_referral">{t('transactions.types.adminDeductReferral')}</option>
            <option value="admin_add_cashback">{t('transactions.types.adminAddCashback')}</option>
            <option value="admin_deduct_cashback">{t('transactions.types.adminDeductCashback')}</option>
          </select>
        </div>

        {/* Status Filter */}
        <div>
          <label className="block text-sm font-medium text-neutral-light mb-2 font-body">
            {t('transactions.filters.status')}
          </label>
          <select
            value={filters.status || ''}
            onChange={(e) => handleFilterChange('status', e.target.value || undefined)}
            className="w-full px-4 py-2 card-glass rounded-lg text-neutral-light focus:outline-none focus:ring-2 focus:ring-brand-accent focus:border-transparent transition-all duration-300 font-body"
          >
            <option value="">{t('transactions.filters.all')}</option>
            <option value="pending">{t('transactions.status.pending')}</option>
            <option value="completed">{t('transactions.status.completed')}</option>
            <option value="failed">{t('transactions.status.failed')}</option>
            <option value="reversed">{t('transactions.status.reversed')}</option>
          </select>
        </div>

        {/* Payment Method Filter */}
        <div>
          <label className="block text-sm font-medium text-neutral-light mb-2 font-body">
            {t('transactions.filters.paymentMethod')}
          </label>
          <select
            value={filters.paymentMethod || ''}
            onChange={(e) => handleFilterChange('paymentMethod', e.target.value || undefined)}
            className="w-full px-4 py-2 card-glass rounded-lg text-neutral-light focus:outline-none focus:ring-2 focus:ring-brand-accent focus:border-transparent transition-all duration-300 font-body"
          >
            <option value="">{t('transactions.filters.all')}</option>
            <option value="Crypto">Crypto</option>
            <option value="Syriatel Cash">Syriatel Cash</option>
            <option value="Sham Cash">Sham Cash</option>
          </select>
        </div>
      </div>

      {/* Clear Filters Button */}
      {(filters.type || filters.status || filters.paymentMethod) && (
        <button
          onClick={() => onFiltersChange({ page: 1, limit: filters.limit || 20 })}
          className="px-4 py-2 bg-neutral-dark text-neutral-light font-body rounded-lg hover:bg-neutral-dark/80 transition-all duration-300"
        >
          {t('transactions.filters.clear')}
        </button>
      )}
    </div>
  );
}

